import styled from '@emotion/styled'
import { Box, Card, Typography } from '@mui/material'
import { colors, typography } from '@resiliatech/birdsong'

export const MetricsCardContainer = styled(Box)`
  display: flex;
  gap: 16px;
  margin-top: 16px;
  width: 100%;
`

export const MetricsCardStyled = styled(Card)({
  backgroundColor: colors.feedback.infoLight,
  borderRadius: '8px',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
  padding: '16px',
  height: '125px',
  flexGrow: 1,
  flexBasis: '22%',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '16px',
})

export const MetricsCardHeader = styled(Typography)`
  padding: 6px;
  margin-bottom: 4px;
  ${typography.down1.regularSans};
  font-weight: bold;
  text-transform: uppercase;
`
export const MetricsValue = styled(Typography)`
  ${typography.up3.regularSans};
  margin-bottom: 4px;
  padding: 6px;
  align-self: end;
`
